import { render } from "./GstReturn.vue?vue&type=template&id=1cc9407a&scoped=true"
import script from "./GstReturn.vue?vue&type=script&lang=js"
export * from "./GstReturn.vue?vue&type=script&lang=js"

import "./GstReturn.vue?vue&type=style&index=0&id=1cc9407a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1cc9407a"

export default script